import FormItem from "components/Form/FormItem";
import { finalPriceCalc } from "containers/PageAddListing/PrivateTrip/stepper/PrivateStepThree";
import { getCommissionSetting } from "functions/redux/country/action";
import { currency } from "functions/redux/general/action";
import { dataDeleteService, getServices, updateFormTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import NcModal from "shared/NcModal/NcModal";
import Textarea from "shared/Textarea/Textarea";
import ncNanoId from "utils/ncNanoId";

interface OpenStepFourProps {
    form: any
}

type Service = {
    id?: number | null,
    name: string | null,
    code: string | null,
    isActive?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    price: number | null,
    description: string | null
}
const OpenStepFour: FC<OpenStepFourProps> = ({ form }) => {
    const dispatch = useDispatch();
    const { listing, countriesReducer } = useSelector((state: RootStore) => state);
    let [selectedServices, setSelectedService] = useState<Service[]>(form?.productService ?? []);
    const [serviceTxt, setServiceTxt] = useState("");
    const [onEdit, setOnEdit] = useState<Service | number>(0);
    const [addCustom, setAddCustom] = useState<Service | number>(0);
    const [showFinalPriceModal, setShowFinalPriceModal] = useState(false);
    const { commissionSetting } = countriesReducer;
    const [showService, setshowService] = useState(false);
    const [showServiceClick, setshowServiceClick] = useState(false);
    const [editPriceService, seteditPriceService] = useState<number>(0);
    const [editDescService, seteditDescService] = useState('');
    const [isUndo, setIsUndo] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {

        if (countriesReducer.commissionSetting == null) {
            dispatch(getCommissionSetting());
        }
    }, []);
    const updateServiceForm = () => {
        dispatch(updateFormTrip('productService', selectedServices));
    }
    const findInArray = (item: any) => {
        var index: any = selectedServices.find((o, index) => {

            if ((o.code === item.code) && item.code !== undefined && o.code !== undefined) {
                return index
            } else if (o.id === item.id) {
                return index
            }
            return index;
        });

        // return index;
    }
    const findArrayIndex = (item: any) => {
        var nilai = -1;
        var innn: any = selectedServices.findIndex((o, index) => {
            if (nilai > -1) {
                return false;
            }
            if ((o.code === item.code) && item.code !== undefined && o.code !== undefined) {
                nilai = index
            } else if (o.name === item.name) {
                nilai = index
            }
            // return false;
        });
        return nilai;

    }


    const findInArrayAdd = (item: any) => {
        var nilai = undefined;
        var innn: any = selectedServices.findIndex((o, index) => {

            if ((o.code === item.code) && item.code !== undefined && o.code !== undefined) {
                nilai = index
            }
        });
        return nilai;
    }

    const removeItem = async (item: any) => {
        const index = findArrayIndex(item);

        dispatch(dataDeleteService(selectedServices[index], listing.deleteService))
        selectedServices.splice(index, 1);
        updateServiceForm();
        setIsUndo(true);
    }

    const pickService = (item: any) => {
        item['service'] = item.id;
        delete item['id'];

        const index = findInArrayAdd(item);

        if (index === undefined) {
            selectedServices.push(item);
            updateServiceForm();
        }
        setServiceTxt("");
        setshowService(false);
        setshowServiceClick(!showServiceClick);

    }

    const openAddCustom = () => {
        var nS: Service = {
            name: null,
            code: null,
            price: null,
            description: null
        }
        setAddCustom(nS);
    }

    const renderSearchService = (item: any) => {
        return (<span style={{ cursor: 'pointer' }} key={ncNanoId()} onClick={() => pickService(item)} className="flex items-center justify-between px-5 py-3" >
            <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                {item.name}
            </span>
        </span >);
    }

    const undoService = () => {
        listing.deleteService.map((item: any, key: any) => {
            form.productService.push(item);
        })
        // setSelectedService();
        dispatch(dataDeleteService(null))
        setIsUndo(false);

        // console.log(listing.deleteService[listing.deleteService.length - 1]);
        // ;
        // if (listing.deleteService.length > 0) {
        //     form.productService.push(listing.deleteService[listing.deleteService.length - 1]);
        //     // dispatch(dataDeleteService(listing.deleteService.splice(listing.deleteService.length - 1, 1)))
        //     listing.deleteService.splice(listing.deleteService.length - 1, 1)

        // } else {
        //     setIsUndo(false);
        // }

    }

    const renderService = (item: any) => {
        return (<div key={ncNanoId()} className="flex items-center justify-between py-3">
            <div className="flex flex-col">
                <span className="text-neutral-6000 dark:text-neutral-500 font-medium">
                    {item.name}
                </span>
                {item.description ?
                    <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                        {item.description}
                    </span>
                    : <></>}
            </div>

            <div className="flex flex-row relative">
                <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                    {item.price ? currency(item.price) : '-'}
                </span>
                <span className="ml-2" onClick={() => setOnEdit(item)}>
                    <i className="text-lg text-neutral-400 las la-edit hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"></i>
                </span>
                <span className="ml-2" onClick={() => removeItem(item)}>
                    <i className="text-lg text-neutral-400 las la-times-circle hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"></i>
                </span>
            </div>
        </div>
        );
    }

    return (
        <div>
            <NcModal
                isOpenProp={onEdit !== 0}
                renderTrigger={() => { return (<></>); }}
                renderContent={() => {
                    return (
                        <div>
                            <FormItem label={t('add_service_price')}>
                                <div className="relative">
                                    <Input defaultValue={typeof onEdit !== "number" ? onEdit.price?.toString() : ""} className=" !pr-10" placeholder="0.00" onChange={(e) => {
                                        if (typeof onEdit !== "number") {
                                            // onEdit.price = parseInt(e.target.value);
                                            seteditPriceService(parseInt(e.target.value))
                                        }

                                    }} />
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <span className="text-gray-500">USD</span>
                                    </div>
                                </div>
                            </FormItem>
                            <FormItem label={t('add_service_desc')} className="mt-2">
                                <Textarea defaultValue={typeof onEdit !== "number" ? onEdit.description?.toString() : ""} rows={2} placeholder={t('add_service_desc_placeholder')} onChange={(e) => {
                                    if (typeof onEdit !== "number") {
                                        seteditDescService(e.target.value);
                                    }
                                }} />
                            </FormItem>

                            <div className="flex justify-end space-x-5 mt-6">
                                <ButtonPrimary className="w-full" onClick={() => {
                                    if (typeof onEdit !== "number") {
                                        if (editPriceService !== 0) {
                                            onEdit.price = editPriceService;
                                        }
                                        if (editDescService !== '') {
                                            onEdit.description = editDescService;
                                        }
                                        selectedServices.map(p =>
                                            p.code === onEdit.code
                                                ? onEdit
                                                : p
                                        );
                                        updateServiceForm();
                                        setOnEdit(0);
                                        seteditDescService('');
                                        seteditPriceService(0);
                                    }
                                }} >
                                    {t('save')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    );
                }}
                contentExtraClass="w-max"
                onCloseModal={() => setOnEdit(0)}
                modalTitle={typeof onEdit !== "number" ? onEdit.name : ''}
            />

            <NcModal
                isOpenProp={addCustom !== 0}
                renderTrigger={() => { return (<></>); }}
                contentExtraClass="w-6/12"
                renderContent={() => {
                    return (
                        <div >
                            <FormItem label={t('add_service_name') + "*"}>
                                <Input className="" placeholder={t('add_service_name')} onChange={(e) => {
                                    if (typeof addCustom !== "number") {
                                        addCustom.name = e.target.value;

                                    }

                                }} />
                            </FormItem>
                            <FormItem label={t('add_service_price')}>
                                <div className="relative">
                                    <Input className=" !pr-10" placeholder="0.00" onChange={(e) => {
                                        if (typeof addCustom !== "number") {
                                            addCustom.price = parseInt(e.target.value);
                                        }

                                    }} />
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <span className="text-gray-500">USD</span>
                                    </div>
                                </div>
                            </FormItem>
                            <FormItem label={t('add_service_desc')} className="mt-2">
                                <Textarea rows={2} placeholder={t('add_service_desc_placeholder')} onChange={(e) => {
                                    if (typeof addCustom !== "number") {
                                        addCustom.description = e.target.value;
                                    }
                                }} />
                            </FormItem>

                            <div className="flex justify-end space-x-5 mt-6">
                                <ButtonPrimary className="w-full" onClick={() => {
                                    if (typeof addCustom !== "number") {
                                        if (addCustom.code == null) {
                                            addCustom.code = ncNanoId();
                                            selectedServices.push(addCustom);
                                        } else {
                                            selectedServices.map(p =>
                                                p.code === addCustom.code
                                                    ? onEdit
                                                    : p
                                            );
                                        }
                                        updateServiceForm();
                                        setAddCustom(0);
                                    }
                                }} >
                                    {t('save')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    );
                }}
                onCloseModal={() => setAddCustom(0)}
                modalTitle={t('add_new_custom_title')}
            />
            <NcModal
                isOpenProp={showFinalPriceModal}
                renderTrigger={() => { return (<></>); }}
                // contentExtraClass="w-6/12"
                renderContent={() => {
                    return <div>
                        <span className="nc-Badge inline-flex px-2.5 py-1 rounded-full font-medium text-xs relative text-green-800 bg-green-100  relative">
                            Commission fee applied to maintain our payment system and improve our service for our users
                        </span>
                        <div className="mt-5">
                            <div className="flex flex-row sm:justify-between mb-1">
                                <h2 className="text-sm font-regular">Basic Price*</h2>
                                <h2 className="text-sm font-regular">
                                    {form?.totalPrice ? currency(form?.totalPrice) : '-'}
                                </h2>
                            </div>

                            <div className="flex flex-row sm:justify-between mb-2">
                                <h2 className="text-sm font-medium">
                                    {`With commission ${commissionSetting?.guideFee}${commissionSetting?.isGuideFeePercent == 1 ? '%' : ''
                                        }`}
                                </h2>
                                <h2 className="text-sm font-medium">
                                    {form?.totalPrice
                                        ? currency(
                                            finalPriceCalc(
                                                form?.totalPrice,
                                                commissionSetting?.guideFee,
                                                commissionSetting?.isGuideFeePercent,
                                            ),
                                        )
                                        : '-'}
                                </h2>
                            </div>

                            {selectedServices.length > 0 ? (
                                <h2 className="text-sm font-medium">
                                    Services
                                </h2>) : <></>}
                            {selectedServices.map((item, k) => {
                                return (
                                    <div key={`serv_${k}`}>
                                        <div className="flex flex-row sm:justify-between mb-1">
                                            <h2 className="text-sm font-regular">{item.name}</h2>
                                            <h2 className="text-sm font-regular">
                                                {item?.price != null && item?.price > 0 ? currency(item?.price) : 'Free'}
                                            </h2>
                                        </div>
                                        {item?.price != null && item?.price > 0 ?
                                            <div className="flex flex-row sm:justify-between mb-2">
                                                <h2 className="text-sm font-medium"> {`With commission ${commissionSetting?.addServiceFee
                                                    }${commissionSetting?.addServiceFeePercent == 1
                                                        ? '%'
                                                        : ''
                                                    }`}</h2>
                                                <h2 className="text-sm font-medium">
                                                    {item?.price != null && item?.price > 0 ? currency(
                                                        finalPriceCalc(
                                                            item?.price,
                                                            commissionSetting?.addServiceFee,
                                                            commissionSetting?.addServiceFeePercent,
                                                        ),
                                                    ) : 'Free'}
                                                </h2>
                                            </div>
                                            : <></>}
                                    </div>
                                );
                            })

                            }

                        </div>


                    </div>;
                }}
                onCloseModal={() => setShowFinalPriceModal(false)}
                modalTitle="Your final price"
            />
            <h2 className="text-2xl font-semibold">{t('pricing_services')}</h2>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 mt-2 mb-4"></div>
            <div className="">
                <FormItem label={t('trip_price') + "*"}>
                    <div className="relative">
                        <Input className=" !pr-10" value={form?.totalPrice ?? 0} placeholder="0.00" onChange={(e) => dispatch(updateFormTrip('totalPrice', e.target.value))} />
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <span className="text-gray-500">USD</span>
                        </div>
                    </div>
                </FormItem>
                <span onClick={async () => {
                    if (countriesReducer.commissionSetting == null) {
                        await dispatch(getCommissionSetting());
                        if (countriesReducer.commissionSetting != null) {
                            setShowFinalPriceModal(true);
                        }
                    } else {
                        setShowFinalPriceModal(true);
                    }
                }
                } className="flex flex-row sm:flex-row sm:flex-start mt-8 mb-2 ">
                    <i className="text-lg text-red-800 las la-question hover:text-red-800 dark:hover:text-red-800 cursor-pointer"></i>
                    <span className="nc-Badge inline-flex px-2.5 py-1 rounded-full font-medium text-xs relative text-red-800 bg-red-100  relative">Your final price with commission fee</span>
                </span>
                <FormItem label={t('add_services')}>
                    <div className="flex flex-col sm:flex-row sm:justify-between ">
                        <Input placeholder={t('add_services_placeholder')} value={serviceTxt}
                            onClick={() => {
                                setshowServiceClick(!showServiceClick);
                                if (showServiceClick) {
                                    setshowService(true);
                                } else {
                                    setshowService(false);
                                }
                            }}
                            onFocus={(e) => {
                                setServiceTxt(e.target.value);
                                dispatch(getServices(e.target.value));
                                setshowService(true);
                            }}
                            onChange={(e) => {
                                setServiceTxt(e.target.value);
                                dispatch(getServices(e.target.value));
                                setshowService(true);
                            }} />
                        <ButtonPrimary className="flex-shrink-0 ml-2" onClick={openAddCustom}>
                            <i className="text-lg las la-plus"></i>
                            <span className="ml-2 text-sm">{t('add_custom')}</span>
                        </ButtonPrimary>
                    </div>

                    {showService ?
                        <div className="flow-root px-4" style={{ position: 'absolute', backgroundColor: 'white', zIndex: 10, boxShadow: "1px 3px 1px #9E9E9E", minWidth: 350, maxHeight: 400, overflowY: 'auto' }}>
                            <div className="-my-3  mt-2 divide-y divide-neutral-100 dark:divide-neutral-800">
                                {listing.services.map((item: any) => renderSearchService(item))}
                            </div>
                        </div> : <></>
                    }
                    <div className="flow-root px-4">
                        <div className="-my-3  mt-2 divide-y divide-neutral-100 dark:divide-neutral-800">
                            {selectedServices.map((item: any) => renderService(item))}
                        </div>
                    </div>
                    {isUndo && (
                        <div className="flex flex-row justify-end mt-2">
                            <button onClick={() => {
                                undoService();
                            }} className="bg-neutral-100 text-neutral-700" style={{ paddingRight: 5, paddingLeft: 5, borderRadius: 50, fontSize: 14 }}>Undo</button>
                        </div>
                    )}
                </FormItem>


            </div>
        </div>
    );
}

export default OpenStepFour;